import Slider from './slider'
export * from './slider'
export default Slider
